import {useMutation} from "@tanstack/react-query";
import {toast} from "sonner";

import {TOAST_CONFIG} from "@/lib/constansts";
import {useInvalidate} from "@/src/modules/core/hooks";
import {meService} from "@/src/modules/core/services/me";

import {getHouseholdOccupantErrorMessage} from "../lib/occupant-errors";
import {householdService} from "../service";
import type {RevokeHouseholdOccupantRequest} from "../types/occupant";

type UseRevokeHouseholdOccupantParams = {
  onSuccess?: () => void;
};

export default function useRevokeHouseholdOccupant(params?: UseRevokeHouseholdOccupantParams) {
  const invalidate = useInvalidate("households");

  return useMutation({
    mutationFn: ({id, body}: {id: number; body: RevokeHouseholdOccupantRequest}) =>
      householdService.revokeOccupant(id, body),
    retry: false,
    onSuccess: async () => {
      await meService.getMe();
      invalidate();
      toast.success("Tenancy ended", TOAST_CONFIG);
      params?.onSuccess?.();
    },
    onError: (error) => {
      toast.error(
        getHouseholdOccupantErrorMessage(error, "Could not end tenancy. Please try again."),
        TOAST_CONFIG,
      );
    },
  });
}
